<rb-loading-spinner *ngIf="dataLoadingBCEvents" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="(errorMessageBCEvents || errorMessagePredictedBatteryCondition) && !dataLoadingBCEvents">
    <rb-callout type="warning">
        No data for "Fleet Battery Condition - Predicted ({{ fleetStatus?.[0]?.predictionDays !== null ? (fleetStatus?.[0]?.predictionDays | inTime:true) : ('In 1 year') }})" chart.
    </rb-callout>
</div>
<div [id]="chartId"></div>
<div class="p-2" *ngIf="!dataLoadingBCEvents && !errorMessageBCEvents && !errorMessagePredictedBatteryCondition">
    <div class="shaded-container">
        Share of vehicles within your fleet rated as "above average", "average", or "below average". This share is shown for the predicted status.
        Please note that the ratings for some batteries are still pending. The proportion of these batteries within the entire fleet is indicated in gray on the pie chart.
    </div>
</div>